import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';
import { AsyncPageRender } from '../../../Components/AsyncComponent';
import { ProtectedRoute } from '../../../Components/Layout/ProtectedRoute';

export const routes$ = {
    Questionnaire: AsyncPageRender(() => pageModule(import('./Questionnaire'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/customer-question'} component={ProtectedRoute(routes$.Questionnaire)} />
        </>
    );
}

export default Router;
